import bunyan from 'bunyan';
import { auditLoggerPath, auditLoggerLevel } from 'config';
import path from 'path';
import metrics from 'metrics';

// Used on client to "do nothing".
const clientLogger = {
  trace() {},
  debug() {},
  info() {},
  warn() {},
  error() {
    // Metric to get a scale on how many errors would be logged client-side.
    // Intention is if manageable, we call an API to log these server side.
    metrics.count('clienterrorlogged', []);
  }
};

function resSerializer(res) {
  return {
    statusCode: res.statusCode || res.status,
    headers: res._headers || res.header
  };
}

function createLogger() {
  if (ENV.CLIENT) {
    return clientLogger;
  }
  return bunyan.createLogger({
    name: 'audit',
    streams: [
      {
        level: auditLoggerLevel,
        type: 'rotating-file',
        period: '6h',
        count: 4,
        path: path.join(process.env.PWD, auditLoggerPath.replace('.', `.pid-${process.pid}.`))
      }
    ],
    serializers: {
      err: bunyan.stdSerializers.err,
      req: bunyan.stdSerializers.req,
      res: resSerializer,
      apiRequest: bunyan.stdSerializers.req,
      apiResponse: resSerializer
    }
  });
}

const log = createLogger();

function middleware(req, res, next) {
  log.info({ req }, `Request ${req.path}`);

  const oldEnd = res.end;
  res.end = (...args) => {
    log.info({ res }, `Response ${req.path}`);
    oldEnd.apply(res, args);
  };

  next();
}

export {
  log,
  middleware
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/logger/index.js
 **/